import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const list = () => {
	return Client.get('/admin/api/profile-print-format');
};
const listCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/print-format`);
};

const update = (val) => {
	return Client.put('/admin/api/profile-print-format', val);
};
const updateCloud = (merchantId, branchId, val) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/print-format`, val);
};

export default {
	list,
	update,
	listCloud,
	updateCloud,
};
